import { render } from "./CollectionDetailedSearchOldMaterials.vue?vue&type=template&id=2d0ffac7&scoped=true&ts=true"
import script from "./CollectionDetailedSearchOldMaterials.vue?vue&type=script&lang=ts"
export * from "./CollectionDetailedSearchOldMaterials.vue?vue&type=script&lang=ts"

import "./CollectionDetailedSearchOldMaterials.vue?vue&type=style&index=0&id=2d0ffac7&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d0ffac7"]])

export default __exports__